import { UserProcessStateDto } from '@/api/generated';
import Loader from '@/components/Loader.tsx';
import { useGetProcess } from '@/hooks/useGetProcess.util.ts';
import Conflict409View from '@/views/409/Conflict409.view.tsx';
import ErrorsView from '@/views/errors/ErrorsView.tsx';
import InitializeQuizPage from '@/views/process/pages/InitializeQuizPage.tsx';
import PersonalDataForm from '@/views/process/pages/personalDataForm/PersonalDataForm.tsx';
import QuizFinishedPage from '@/views/process/pages/QuizFinishedPage.tsx';
import SkillsAssessmentCollectedPage from '@/views/process/pages/SkillsAssessmentCollectedPage.tsx';
import React, { FC } from 'react';

import QuizInitializedPage from '../pages/QuizInitializedPage';

const pages: Record<UserProcessStateDto, FC> = {
  [UserProcessStateDto.CandidatePersonalDataCollected]: InitializeQuizPage,
  [UserProcessStateDto.CandidateSkillsAssessmentCollected]: SkillsAssessmentCollectedPage,
  [UserProcessStateDto.None]: () => <div />,
  [UserProcessStateDto.ProcessInitialized]: PersonalDataForm,
  [UserProcessStateDto.QuizExpired]: Conflict409View,
  [UserProcessStateDto.QuizFinished]: QuizFinishedPage,
  [UserProcessStateDto.QuizInitialized]: QuizInitializedPage,
  [UserProcessStateDto.QuizRevisitsExceeded]: ErrorsView,
  [UserProcessStateDto.QuizPointsResultReady]: QuizFinishedPage,
};

const ProcessStateRenderer: React.FC = () => {
  const { error, isGetting, process } = useGetProcess();

  if (error) {
    return <ErrorsView />;
  }

  const ComponentToRender = pages[process?.state ?? UserProcessStateDto.None];

  return (
    <>
      <ComponentToRender />
      {isGetting && <Loader className="min-h-dvh" />}
    </>
  );
};

export default ProcessStateRenderer;
